import { Component } from 'react';

export default class CaretRightIcon extends Component {
    render() {
        return (
            <svg width="100%" height="100%" fill="inherit" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 10.5L5.5 5.5L0.5 0.5L0.5 10.5Z" fill="inherit" fill-opacity="0.54"/>
            </svg>
        )
    }
};